module.exports = __webpack_public_path__ + "img/bg.2fd38573.png";